
import Vue from 'vue'

export default Vue.extend({
    data: () => {
        return {
            tab: 0,
            address: ''
        }
    },
    computed: {
        tabNames() { return ['summary', 'transfers', 'events'] }
    },
    watch: {
        tab(newTab: number) {
            this.$router.replace({ name: this.tabNames[newTab] })
        }
    },
    created() {
        this.$ga.page('/insight/account')
        this.address = this.$route.params.address.toLowerCase()
        this.tab = this.tabNames.indexOf(this.$route.name!)
        if (this.tab < 0) {
            this.tab = 0
        }
    }
})
